export default {"src":"/_next/static/media/blaze-white.ea95fa4c.svg","height":250,"width":350,"blurWidth":0,"blurHeight":0};